import type { Folder } from '@src/types.ts/story';

/** Display name of the virtual folder holding stories not filed anywhere. */
export const UNASSIGNED_FOLDER_NAME = 'Unassigned';

/**
 * Ancestor trail of `folderId`, root first. Stops at a cycle rather than
 * looping; `cycleAt` is the folder the walk re-entered, when it did.
 */
export const folderTrail = (
  byId: Map<string, Folder>,
  folderId: string,
): { trail: Folder[]; cycleAt?: string } => {
  const trail: Folder[] = [];
  const guard = new Set<string>();
  let cursor = byId.get(folderId);
  while (cursor && !guard.has(cursor.id)) {
    guard.add(cursor.id);
    trail.unshift(cursor);
    cursor = cursor.parentId ? byId.get(cursor.parentId) : undefined;
  }
  return { trail, cycleAt: cursor?.id };
};
